// Win check per ECONOMY §1:
//   WIN LEVEL WHEN passive income (per week) >= living expenses (per week)
// The level then unlocks new content. We currently bump profile.level by 1 on each new win.

import type { GameState } from '../state/types.js';
import { livingExpensesForWeek, passiveIncomeForWeek } from '../ledger/selectors.js';

export type WinAssessment = {
  passive: number;
  living: number;
  passed: boolean;
};

export function assessWin(state: GameState, week?: number): WinAssessment {
  const passive = passiveIncomeForWeek(state, week);
  const living = livingExpensesForWeek(state, week);
  return { passive, living, passed: living > 0 && passive >= living };
}
